export type Market = 'AU' | 'NZ' | 'CA'
export type Markets = Market[] | null | undefined

const VALID_MARKETS: readonly Market[] = ['AU', 'NZ', 'CA']

// Absent/null/non-array/empty markets means visible everywhere (MHJ-261105 AC2/AC7).
export function marketControl(markets: Markets, market: string): boolean {
  if (!Array.isArray(markets) || markets.length === 0) return true

  return markets.includes(market as Market)
}

// Guards unvalidated client input (the previewMarket query param): an invalid value must not be
// treated as a market, which would fail closed and hide every market-restricted entry.
export function isValidMarket(value: unknown): value is Market {
  return typeof value === 'string' && VALID_MARKETS.includes(value as Market)
}
